module.exports = __webpack_public_path__ + "static/media/city.1e0bd29d.svg";